import React, { useState } from "react";

function RandomNumber() {

  const [number, setNumber] = useState(null)

 
  const generateNumber = () => {
    const random = Math.floor(Math.random() * 100) + 1;
    setNumber(random);
  }

  return (
    <div style={{
        textAlign: "center",
        marginTop: "60px",
        fontFamily: "Arial",
      }}>
      <h2 style={{ color: "black" }}>Random Number Generator</h2>
       {number === null ? ( <p style={{ fontSize: "20px", color: "black" }}>No number generated yet</p>) 
       : (<p style={{ fontSize: "25px", fontWeight: "bold", color: "green", }}>Generated Number: {number}</p>)}

      
      <button onClick={generateNumber}
      style={{padding: "10px 20px",
          fontSize: "20px",
          backgroundColor: "black",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          
        }}> Generate Random Number
        </button>
    </div>
  );
}

export default RandomNumber;

